import { FileInfoDto, QueryFactory } from '@lmt/shared-types';
import { usePublishDocumentHandler } from '@lmt/unicorn-shared/app/components/documents/richedit/usePublishDocumentHandler';

import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';

import React from 'react';
import {
  RibbonTabType,
  RichEdit,
} from '../../../common/devexpress/RichEdit/dx-richedit';
import { CustomButton } from './CustomButton';
import { useEventCallback } from '@mui/material';
import { openOrDownloadFile } from '../../patients/profile/cases/components/documents/common';

export const readyForPdfButtonId = 'readyForPdfButtonId';

/*
  Component that adds "Ready for PDF" button that finalizes current draft version
  and allows user to print the new version
 */
type Props = {
  richEdit: React.MutableRefObject<RichEdit>;
  tab: RibbonTabType;
  patientId: number;
  dataBlockId: number | undefined;
  documentId: string | undefined;
  groupId: string | undefined;
  templateId: number | undefined | null;
  onNewDocumentId?: (newId: string) => void;
};

export const ReadyForPdfButton: React.FC<Props> = (props) => {
  const i18n = useScopedTranslation('documents');
  const { templateId } = props;
  const { data: patient } = QueryFactory.PatientQuery.useGetPatientQuery(
    props.patientId!,
    {
      enabled: !!props.patientId,
    },
  );

  const { data: documentTemplateRules } =
    QueryFactory.DocumentTemplateRuleQuery.useGetQuery(
      {
        subtenantId: patient?.subtenantId,
      },
      {
        enabled: !!patient?.subtenantId,
      },
    );

  const openDocumentIfNecessary = useEventCallback(
    async (newVersion: FileInfoDto) => {
      const isOpen = documentTemplateRules?.find(
        (x) => x.templateId === templateId,
      )?.isOpeningAfterSaving;
      if (isOpen) {
        await openOrDownloadFile(newVersion);
      }
    },
  );

  const handle = usePublishDocumentHandler({
    ...props,
    richEdit: props.richEdit.current,
    afterPublishAction: openDocumentIfNecessary,
  });

  return (
    <CustomButton
      {...props}
      buttonId={readyForPdfButtonId}
      onClick={handle}
      text={i18n.t('ready_for_pdf.button')}
      icon={'dxre-icon-ProtectDocument'}
    />
  );
};
